import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '../store/';
import utils from '../util/';
import moment from 'moment';
import config from '../config'

Vue.use(Router);
const router = new Router({
  base: '/',
  mode: 'history',
  linkActiveClass: 'active',
  routes: paths,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});
// router gards
router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.state.user,
  moduleName = to.meta.moduleName,
  actionName = to.meta.actionName,
  isCheckPermission = to.meta.isCheckPermission,
  arrForView = ['list', 'detail', 'search'],
  arrForAll = ['add', 'detail', 'edit', 'list', 'search'];
  if(isLoggedIn && isLoggedIn.status !== 'active' && to.name !== 'DisabledUser' ){
    router.replace('/disableduser');
    return;
  }
  else if(isLoggedIn && to.name === 'DisabledUser'){
    //left blank to skip and no action required to perform in this condition
  }
  else{
    if (to.name === 'Login' || to.name === 'ForgotPassword' || to.name === 'ResetPassword' || to.name === 'ChangeEmail' || to.name === 'ConfirmEmail' || to.name === 'Download') {
      if (isLoggedIn && (to.name !== 'ResetPassword' && to.name !== 'ChangeEmail' && to.name !== 'ConfirmEmail' && to.name !== 'Download')) {
        router.replace('/dashboard');
      }
    } else {
      if (!isLoggedIn) {
        let loginUrl = '/login';
        if(store.state.loginType && store.state.loginType != ''){
          loginUrl += '/'+store.state.loginType;
        }
        router.replace(loginUrl);
        return;
      } else if(isCheckPermission && typeof store.state.user.permissions[moduleName] === 'undefined' || (store.state.user.permissions[moduleName] === 'view' && !arrForView.includes(actionName)) ){
        router.replace('/AccessDenied');
        return;
      } else if(isCheckPermission && typeof store.state.user.permissions[moduleName] === 'undefined' || (store.state.user.permissions[moduleName] === 'all' && !arrForAll.includes(actionName))){
        router.replace('/AccessDenied');
        return;
      } 
    }
  }
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
  let sessionTime = moment(new Date()).unix() - store.state.loginTimeStamp;
  // let curPath = Router.app._route.path.toString();
  if(sessionTime <= config.sessionTimeForRefreshToken){
    utils.updateLoginTimeStamp(store);
  }
  const isLoggedIn = store.state.user;
  if(isLoggedIn && isLoggedIn.status=='active' && to.name !== 'DisabledUser' && (typeof isLoggedIn.back_user_uuid == 'undefined' || isLoggedIn.back_user_uuid == '')){
    utils.generatePin(store,isLoggedIn);
  }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js